export enum SubMenu {
  terverifikasi = 'Terverifikasi',
  pending = 'Sedang Menunggu',
  reject = 'Ditolak',
}

export enum StatusDetailPrivilage {
  terverifikasi = 'DETAIL_REGISTERED',
  pending = 'DETAIL_PENDING',
  reject = 'DETAIL_REJECT',
}

export enum RetailerStatus {
  terverifikasi = 'TERVERIFIKASI',
  pending = 'PENDING',
  reject = 'REJECT',
  nonactive = 'NONACTIVATED',
}

export enum RetailerStatusBadge {
  Aktif = 'badge__status--blue',
  Diproses = 'badge__status--pending',
  Ditolak = 'badge__status--reject',
}
